/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-25 15:27:23
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-02-25 17:26:08
 * @FilePath: /designcenter/src/components/Icon/icons.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 修改导入方式
const svgFiles = import.meta.glob('./icons/*.svg', {
  eager: true,
  import: 'default',
})

// 注册所有图标
export function registerIcons() {
  const svgSprite = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svgSprite.setAttribute('aria-hidden', 'true')
  svgSprite.style.position = 'absolute'
  svgSprite.style.width = '0'
  svgSprite.style.height = '0'
  svgSprite.style.overflow = 'hidden'

  for (const path in svgFiles) {
    const name = path.match(/\.\/icons\/(.*)\.svg$/)?.[1]
    if (!name) continue

    const SvgComponent = svgFiles[path]
    const temp = document.createElement('div')
    temp.innerHTML = typeof SvgComponent === 'string' ? SvgComponent : SvgComponent()

    const svgContent = temp.querySelector('svg')
    if (!svgContent) continue

    const symbol = document.createElementNS('http://www.w3.org/2000/svg', 'symbol')
    symbol.id = `icon-${name}`

    // 复制必要的SVG属性
    const viewBox = svgContent.getAttribute('viewBox')
    if (viewBox) {
      symbol.setAttribute('viewBox', viewBox)
    }

    // 复制SVG内容
    while (svgContent.firstChild) {
      symbol.appendChild(svgContent.firstChild)
    }

    svgSprite.appendChild(symbol)
  }

  document.body.appendChild(svgSprite)
}
